import { View } from "@/components/ui/view";
import { VStack } from "@/components/ui/vstack";
import { HStack } from "@/components/ui/hstack";
import { Center } from "@/components/ui/center";
import { Text } from "@/components/ui/text";
import { Image } from "@/components/ui/image";
import { Button } from "@/components/ui/button";
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'i18n-js';
import * as MediaSelector from '../../components/media/MediaSelector';
import { backendLogin } from '../../stores/thunks';
import { TouchableOpacity } from 'react-native-gesture-handler';
import FloatingLabelInput from '../../components/basic/FloatingLabelInput';
import { switchScreen } from '../../hooks/navigate';
import { inaLogo, inaBack } from '../../assets/images';
import { IconM } from '../../components/media/IconsV2';

function Logo() {
    const inAColor = useSelector((state) => state.settings.inAColor == undefined ? 0 : state.settings.inAColor)
    return <Image source={inaLogo} alt={i18n.t('global.missingImage')} className="w-[480px] h-[480px]" />;
}

const InputFields = ({ navigation }) => {
    const [userid, setUserid] = useState('');
    const [password, setPassword] = useState('');
    const [hidden, setHidden] = useState(true);
    const dispatch = useDispatch()

    const login = () => {
        dispatch(backendLogin('LOGIN', { name: userid.trim(), passwd: password.trim() }))
    }

    const LoginButton = () => {
        return (
            <Button onPress={login} className="bg-[#24A347] py-3 px-5 active:bg-ina_green self-end">
                <HStack space='sm' className="items-center">
                    <Text className="font-[400] text-lg text-secondary-50">{i18n.t('login.login2')}</Text>
                    <IconM className='text-secondary-50' name='login' />
                </HStack>
            </Button>
        );
    }

    return (
        <VStack space='4xl' className="w-[450px]">
            <Text className="text-secondary-900 text-xl font-[800]">{i18n.t('login.loginData')}</Text>
            <FloatingLabelInput size='xl' label={i18n.t('login.email')} textContentType='emailAddress' autoCapitalize='none'
                keyboardType='email-address' autoCorrect={false} autoCompleteType='email'
                placeholder={i18n.t('login.email')} onChangeText={(text) => setUserid(text)} />
            <VStack space='xl'>
                <FloatingLabelInput label={i18n.t('login.password')} type={hidden ? 'password' : ''}
                    autoCapitalize='none'
                    autoCorrect={false} placeholder={i18n.t('login.password')}
                    onChangeText={(text) => setPassword(text)} onPress={() => { setHidden(!hidden) }}
                    iconR={hidden ? 'visibility-off' : 'visibility'}
                    onSubmitEditing={login}
                />
                <TouchableOpacity onPress={() => switchScreen(navigation, 'ModalResetPW', { mail: userid })}>
                    <Text bold className="text-ina_blue text-md text-right">{i18n.t('login.resetPW')}</Text>
                </TouchableOpacity>
            </VStack>
            <LoginButton />
        </VStack>
    );
}

export default function Login({ navigation }) {

    useEffect(() => {
        MediaSelector.requestPermissions()
        MediaSelector.ensureDirExists()
    }, [])

    return (
        <View className="flex-1">
            <Center className="min-w-[100%] min-h-[100%]">
                <Image source={inaBack} alt={i18n.t('global.missingImage')} className="absolute w-[1440px] h-[800px]" />
                <HStack className="min-h-[480px]">
                    <Center className="rounded-tl-lg rounded-bl-lg shadow-hard-3 min-w-[480px] bg-primary-900">
                        <Logo />
                    </Center>
                    <Center className="rounded-tr-lg rounded-br-lg shadow-hard-3 min-w-[480px] bg-secondary-50 p-5">
                        <InputFields navigation={navigation} />
                    </Center>
                </HStack>
            </Center>
        </View>
    );
}